import { Check, Minus } from "lucide-react";
import { SectionHead, FadeUp } from "@/components/Reveal";
import { COMPARE } from "@/lib/content";

const Value = ({ value, primary }) => {
  if (value === true) {
    return (
      <span className={`inline-flex items-center gap-2 font-medium ${primary ? "text-neon" : "text-white"}`}>
        <Check size={16} strokeWidth={3} className={primary ? "text-neon" : "text-mist"} />
        No
      </span>
    );
  }
  if (value === false) {
    return (
      <span className="inline-flex items-center gap-2 text-mist">
        <Minus size={16} strokeWidth={3} className="text-dim" />
        Yes
      </span>
    );
  }
  return <span className={primary ? "text-neon font-medium" : "text-mist"}>{value}</span>;
};

export default function ComparisonTable() {
  return (
    <section className="relative py-24 sm:py-32 border-t border-white/5" data-testid="comparison-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <SectionHead
          eyebrow="Head to head"
          title="Web-based vs. hardware vs. software"
        >
          Why a browser tab beats a USB stick taped under your desk.
        </SectionHead>

        <FadeUp delay={0.1}>
          <div className="mt-14 overflow-x-auto rounded-2xl border border-white/5" data-testid="comparison-table">
            <table className="w-full min-w-[720px] border-collapse">
              <thead>
                <tr className="border-b border-white/5">
                  <th className="text-left font-mono text-[11px] uppercase tracking-[0.2em] text-dim font-medium px-6 py-5">
                    Feature
                  </th>
                  {COMPARE.columns.map((col, i) => (
                    <th
                      key={col}
                      className={`text-left font-mono text-[11px] uppercase tracking-[0.2em] px-6 py-5 font-bold ${
                        i === 0 ? "text-neon bg-neon/[0.04]" : "text-dim"
                      }`}
                    >
                      {col}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {COMPARE.rows.map((row) => (
                  <tr key={row.feature} className="border-b border-white/5 hover:bg-white/[0.02] transition-colors">
                    <td className="px-6 py-5 text-white text-[15px] font-medium">{row.feature}</td>
                    {row.values.map((v, i) => (
                      <td
                        key={i}
                        className={`px-6 py-5 text-[15px] ${i === 0 ? "bg-neon/[0.04]" : ""}`}
                      >
                        <Value value={v} primary={i === 0} />
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </FadeUp>
      </div>
    </section>
  );
}
